module.exports = __webpack_public_path__ + "img/question.d7c21b5e.svg";